var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26149 0 0 4.26149 0 9.5C0 14.7385 4.26149 19 9.5 19C14.7385 19 19 14.7385 19 9.5C19 4.26149 14.7385 0 9.5 0ZM14.3149 7.48682L9.16906 12.6326C9.01468 12.7869 8.81203 12.8646 8.60938 12.8646C8.40672 12.8646 8.20407 12.7869 8.04969 12.6326L5.47682 10.0597C5.16719 9.7502 5.16719 9.2498 5.47682 8.94032C5.78631 8.63068 6.28656 8.63068 6.59619 8.94032L8.60938 10.9535L13.1956 6.36745C13.5051 6.05782 14.0053 6.05782 14.3149 6.36745C14.6244 6.67693 14.6244 7.17719 14.3149 7.48682Z",
    fill: "#57AC2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckMark);
export default __webpack_public_path__ + "static/media/circle-check-mark.0f8703ee8d3b5bb5e6d7d5888c3c911f.svg";
export { ForwardRef as ReactComponent };